/**
 * ...
 * @param {string} duration - duration in ISO format
 * @returns {string} fomarttedDuration - comprehensive duration format
 */
const FomarttedDuration = (duration) =>
  duration.replace('P', '').replace('T', '').toLowerCase()

export default FomarttedDuration
